// Display data for the reject-code pages: how each rejection-registry section
// is named publicly, which wizard step owns it (labels from
// src/pages/Wizard/stepConfig.js), and which guides explain it. Every guide
// path must exist - check-internal-links.mjs validates the blog ones.
export const REJECT_SECTIONS = {
  BUSINESS: {
    label: "Business details",
    step: "Business",
    guides: [
      { to: "/blog/form-2290-ein-name-control-rejection", label: "Rejected for EIN or name control: how to fix it" },
      { to: "/blog/ein-for-form-2290", label: "EIN for Form 2290" },
    ],
  },
  FORM: {
    label: "Return type",
    step: "Form",
    guides: [{ to: "/blog/form-2290-final-return", label: "Form 2290 final return" }],
  },
  AMENDED_RETURN: {
    label: "Amended return",
    step: "Amended return",
    guides: [
      { to: "/blog/form-2290-weight-increase-amendment", label: "Weight increase amendment" },
      { to: "/blog/form-2290-suspended-vehicle-over-mileage", label: "Suspended truck over the mileage limit" },
    ],
  },
  VIN_CORRECTION: {
    label: "VIN correction",
    step: "VIN correction",
    guides: [{ to: "/blog/form-2290-vin-correction", label: "Form 2290 VIN correction" }],
  },
  TRUCKS: {
    label: "Vehicles",
    step: "Trucks",
    guides: [
      { to: "/blog/taxable-gross-weight-form-2290", label: "Taxable gross weight and categories" },
      { to: "/blog/form-2290-due-date-2026-2027", label: "Due dates by first-used month" },
    ],
  },
  PRIOR_YEAR: {
    label: "Prior-year suspended vehicles",
    step: "Prior year",
    guides: [
      { to: "/blog/suspended-vehicles-category-w", label: "Suspended vehicles and category W" },
      { to: "/blog/form-2290-suspended-vehicle-over-mileage", label: "Suspended truck over the mileage limit" },
    ],
  },
  CREDITS: {
    label: "Credits",
    step: "Credits",
    guides: [
      { to: "/blog/form-2290-credit-sold-destroyed-stolen-truck", label: "Credit for a sold, destroyed, or stolen truck" },
      { to: "/blog/form-2290-credits-and-refunds", label: "Form 2290 credits and refunds" },
    ],
  },
  PAY: {
    label: "Payment",
    step: "Payment method",
    guides: [{ to: "/blog/how-to-pay-form-2290", label: "How to pay Form 2290 tax" }],
  },
};

// Order the hub page shows the sections in - roughly the wizard's own order.
export const SECTION_ORDER = ["BUSINESS", "FORM", "TRUCKS", "PRIOR_YEAR", "CREDITS", "AMENDED_RETURN", "VIN_CORRECTION", "PAY"];
